import { createContext } from 'react'
import { dashTranslations } from './translations.js'

export const LanguageContext = createContext(dashTranslations.english)
